import showToaster from '../../helpers/showToaster';
import { getAllStaticPage as query, updateStaticPageStatus as mutation } from '../../lib/graphql';
import { demoRestriction } from '../../helpers/DemoRestriction/demoRestriction';

export function updateStaticPageStatus(id, isEnable) {

	return async (dispatch, getState, { client }) => {
		try {

			const isRestrict = await dispatch(demoRestriction({}));
			if (isRestrict) return;

			const { data } = await client.mutate({
				mutation,
				variables: { id, isEnable },
				refetchQueries: [{ query }]
			});

			if (data.updateStaticPageStatus.status === "success") {
				showToaster({ messageId: 'updateStatus', toasterType: 'success' })
			} else {
				showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data.updateStaticPageStatus.errorMessage })
			}
		} catch (error) {
			showToaster({ messageId: 'updateFailed', toasterType: 'error' })
			return false;
		}
		return true;
	};
}